import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box, Column, Heading, Button,
} from 'gestalt';
import WebViewer from '@pdftron/webviewer';
import { selectDocToView } from './ViewDocumentSlice.js';
import { storage } from '../../../firebase/firebase.js';
import 'gestalt/dist/gestalt.css';
import './ViewDocument.css';

const ViewDocument = () => {
  const [instance, setInstance] = useState(null);

  const doc = useSelector(selectDocToView);
  const { docRef } = doc;

  const viewer = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    WebViewer(
      {
        path: 'webviewer',
        disabledElements: [
          'ribbons',
          'toggleNotesButton',
          'contextMenuPopup',
        ],
      },
      viewer.current,
    ).then(async (anotherInstance) => {
      // select only the view group
      anotherInstance.setToolbarGroup('toolbarGroup-View');

      setInstance(anotherInstance);

      // load document
      const storageRef = storage.ref();
      const URL = await storageRef.child(docRef).getDownloadURL();
      console.log(URL);
      anotherInstance.docViewer.loadDocument(URL);
    });
  }, [docRef]);

  const download = () => {
    instance.downloadPdf(true);
  };

  const doneViewing = async () => {
    navigate('/fakeDocusign');
  };

  // .......... RENDERING COMPONENT .......... //
  return (
    <div className="prepareDocument">
      <Box display="flex" direction="row" flex="grow">
        <Column span={2}>
          <Box padding={3}>
            <Heading size="md">View Document</Heading>
          </Box>
          <Box padding={3}>
            {/* <Row gap={1}> */}
            {/* <Stack> */}
            <Box padding={2}>
              <Button
                onClick={download}
                accessibilityLabel="download signed document"
                text="Download"
                iconEnd="download"
              />
            </Box>
            <Box padding={2}>
              <Button
                onClick={doneViewing}
                accessibilityLabel="complete signing"
                text="Done viewing"
                iconEnd="check"
              />
            </Box>
            {/* </Stack> */}
            {/* </Row> */}
          </Box>
        </Column>
        <Column span={10}>
          <div className="webviewer" ref={viewer} />
        </Column>
      </Box>
    </div>
  );
};

export default ViewDocument;
